/**
 * The external dependencies.
 */
import React from 'react';
import styled from 'styled-components';
import ModalImage from "react-modal-image";
import {join, length} from 'ramda'
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
/**
 * The internal dependencies.
 */
import Pencil from '../../../assets/images/temp/ico-pencil.png';
import ButtonRound from '../../../components/general/button-round';
import Button from '../../../components/general/button';
import Header from '../../../components/task/shop/header';
import Text from '../../../components/task/shop/text';

import FlexRootWrapper from '../../../components/general/flex-root';
import {isWeekday} from "../../../common/utilities";
import Child from "../child";
import {ts_translate} from "../../../common/clientTranslate";


const StyledDatePicker = styled(DatePicker)`
    text-align: center;
    width: 100px;
`;

const Wrapper = styled(FlexRootWrapper)`
	max-width: 25%;
	background: #fff;
`;

const TaskImageWrapper = styled.img`
	width: 100%;
	height: auto;
	margin: 26px 0;
`;

const ContentWrapper = styled(FlexRootWrapper)`
	font-size: 14px;
	color: #707078;
	padding: 0 30px;

	> span {
		display: flex;
		justify-content: space-between;

		> span {
			color: #000;
		}
	}

	> span + span {
		letter-spacing: -0.03em;
		padding-top: 14px;
		border-top: 1px solid #95989a;
		margin-top: 14px;
	}
`;

const EditButton = styled(ButtonRound)`
	background: url(${Pencil}) ${({color}) => color} center center no-repeat;
	margin-right: 11px;
`;


const WeekButton = styled(Button)`
	width: ${({width}) => width ? width : 'auto'};
	min-width: 0;
`;

const ChildrenContainer = styled.div`

`


const Sidebar = ({
                     taskHeadLine,
                     color = '#43abf3',
                     taskImage,
                     taskTotalQuantity,
                     taskShortNumber,
                     taskCustomer,
                     taskDate,
                     setDate,
                     noWeek,
                     taskDepartments,
                     task,
                     children,
                     taskDeliveryDate,
                 }) => (
    <Wrapper>
        <Header color="#d9d7d7" textColor="#707070;">
            <Text flex>
                <EditButton color={color}/>

                {taskHeadLine || 'Auftrag bearbeiten'}
            </Text>

        </Header>

        <ContentWrapper>
            {taskImage ? <ModalImage
                small={taskImage}
                large={taskImage}
                alt="Kein Bild verfügbar."
            /> : <span style={{marginTop: 25 + 'px'}}>Kein Bild verfügbar.</span>}

            <span>
				Stückzahl insgesamt:

				<span>{taskTotalQuantity}</span>
			</span>

            <span>
                {ts_translate('ERP-Nummer')}:

				<span>{taskShortNumber}</span>
			</span>

            <span>
				Kunde:

				<span>{taskCustomer}</span>
			</span>

            <span>
				Abteilungen:
                <span>{taskDepartments}</span>
			</span>

            {task && <span>
                {ts_translate('Labels')}:
                <span>{task.labels && length(task.labels) > 0 && join(' | ', task.labels)}</span>
			</span>}

            <span>
				Datum:

                {noWeek && <span>{moment(taskDate).format('DD.MM.YYYY')}</span>}
                {!noWeek && <span><StyledDatePicker
                    selected={moment(taskDate).toDate()}
                    onChange={setDate}
                    filterDate={isWeekday}
                    dateFormat={'dd.MM.yy'}
                /></span>}
			</span>

            {taskDeliveryDate && <span>
                {ts_translate('Lieferdatum')}:
                <span>{moment(taskDeliveryDate).format('DD.MM.YYYY')}</span>
			</span>}

            {children && <Child children={children}/>}

        </ContentWrapper>
    </Wrapper>
);

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/task/shop/sidebar.js